<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>SE CONNECTER</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>SE CONNECTER</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-100 pb-170">
    <div class="container">
        <div class="row align-items-center bg-white shadow-lg rounded-4 overflow-hidden login-card">
            <!-- Colonne de gauche avec image et texte explicatif -->
            <div class="col-lg-6 p-0 d-none d-lg-block">
                <div class="login-image-container position-relative">
                    <img src="./assets/img/upload/home/section-1.png" alt="Connexion QUALIFPME" class="img-fluid w-100 login-image" style="height: 100%; object-fit: cover;">
                    <div class="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center p-5 overlay-content" style="background: linear-gradient(135deg, rgba(0, 83, 62, 0.95), rgba(0, 83, 62, 0.85), rgba(0, 83, 62, 0.75))">
                        <div class="content-wrapper">
                            <div class="logo-section mb-4">
                                <img src="./assets/img/LOGO_BSTP.png" alt="Logo QUALIFPME" height="50" class="mb-3 logo-white">
                            </div>
                            <h2 class="text-white mb-4 fw-bold display-6">Bienvenue sur QualifPME</h2>
                            <div class="mb-4">
                                <p class="text-white mb-3 lead">Connectez-vous pour accéder à votre espace entreprise et gérer:</p>
                                <ul class="text-white ps-3 feature-list">
                                    <li class="mb-3 d-flex align-items-center">
                                        <i class="icofont-check-circled text-success me-3"></i>
                                        <span>Vos informations d'entreprise</span>
                                    </li>
                                    <li class="mb-3 d-flex align-items-center">
                                        <i class="icofont-check-circled text-success me-3"></i>
                                        <span>Vos demandes de qualification</span>
                                    </li>
                                    <li class="mb-3 d-flex align-items-center">
                                        <i class="icofont-check-circled text-success me-3"></i>
                                        <span>Vos documents et certifications</span>
                                    </li>
                                    <li class="mb-3 d-flex align-items-center">
                                        <i class="icofont-check-circled text-success me-3"></i>
                                        <span>Votre suivi de progression</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="security-notice bg-white p-4 rounded-3 shadow-sm">
                                <div class="d-flex align-items-center">
                                    <i class="icofont-shield-check text-primary me-3 fs-4"></i>
                                    <div>
                                        <p class="text-dark mb-0 fw-semibold">Sécurité renforcée</p>
                                        <p class="text-muted mb-0 small">Un code de vérification vous sera envoyé par email pour sécuriser votre connexion.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Colonne de droite avec le formulaire -->
            <div class="col-lg-6 p-5">
                <div class="login-form-container">
                    <div class="text-center mb-5">
                        <div class="logo-container mb-4">
                            <img src="./assets/img/LOGO_BSTP.png" alt="Logo QUALIFPME" height="70" class="mb-3 logo-animated">
                        </div>
                        <h2 class="mb-3 fw-bold text-dark">Connexion Entreprise</h2>
                        <p class="text-muted lead">Veuillez saisir votre adresse email</p>
                    </div>
                    
                    <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
                        <div class="form-group mb-4">
                            <label for="email" class="form-label fw-semibold">
                                <i class="icofont-email me-2 text-primary"></i>
                                Adresse électronique
                            </label>
                            <div class="input-group input-group-lg">
                                <span class="input-group-text">
                                    <i class="icofont-email"></i>
                                </span>
                                <input
                                    class="form-control"
                                    type="email"
                                    formControlName="email"
                                    placeholder="Saisissez votre email"
                                    aria-label="Adresse email"
                                    id="email"
                                />
                            </div>
                            <small class="form-text text-muted d-flex align-items-center mt-2">
                                <i class="icofont-info-circle me-2"></i>
                                Nous vous enverrons un code de vérification à cette adresse.
                            </small>
                        </div>

                        <div class="form-group mb-4">
                            <label class="form-label fw-semibold">
                                <i class="icofont-shield me-2 text-primary"></i>
                                Vérification de sécurité
                            </label>
                            <re-captcha
                                class="w-100"
                                id="recaptcha"
                                formControlName="recaptcha"
                            ></re-captcha>
                        </div>

                        <div class="d-grid gap-2 mb-4">
                            <button type="submit" class="btn btn-green btn-lg btn-animated" [disabled]="form.invalid || loading">
                                <span class="btn-content">
                                    <i class="icofont-login me-2"></i> 
                                    CONNEXION 
                                </span>
                                <span class="btn-loading" *ngIf="loading">
                                    <i class="icofont-spinner-alt-1 icofont-spin me-2"></i>
                                    Connexion en cours...
                                </span>
                            </button>
                        </div>
                        
                        <div class="text-center">
                            <div class="divider mb-4">
                                <span class="divider-text">ou</span>
                            </div>
                            <p class="message">
                                N'avez-vous pas encore de compte?
                                <a class="text-primary fw-bold link-animated" routerLink="/create-account">
                                    S'enregistrer ici
                                    <i class="icofont-arrow-right ms-1"></i>
                                </a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <app-loading [loading]="loading" /> -->
